import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { UnoStoreHooks, UiComponents, initialize } from "@simulanisindia/ui";
import Modal from "react-bootstrap/Modal";
import { AudioPrev, MediaCheckIcon, PDFPrev, PlusIcon, VideoPrev, XIcon } from "../../assets/icons/icons";
import pdfIcon from "../../assets/img/pdf.png";
import { AUDIO, IMAGE, PDF, VIDEO } from "../../constant/constant";
import { getFileType } from "../../utils/general";
import { useParams } from "react-router-dom";
import apiclient from "../../apiclient";
import axios from "axios";
import { saveInventoryList } from "../../store/slice/projectSlice";
import SpinnerLoader from "../skeleton/loader";

export const allowedFileTypes = ["image/jpeg", "image/png", "video/mp4", "audio/mpeg", "application/pdf"];

const getAcceptType = (type) => {
  switch (type) {
    case IMAGE:
      return "image/*";
    case VIDEO:
      return "video/*";
    case PDF:
      return "application/pdf";
    case AUDIO:
      return "audio/*";
    default:
      return "*/*";
  }
};

const { useUnoSelector } = UnoStoreHooks;


const IconPopup = ({ show, handleClose, handleChangeHotspot, showTabs=[], hotspotId=null }) => {
  const dispatch = useDispatch();
  const configData = useUnoSelector((state) => state.config);
  const userData = useUnoSelector((state) => state.user);
  const { uuid } = useParams();
  const [activeTab, setActiveTab] = useState(IMAGE);
  const [inventoryType, setInventoryType] = useState([{ name: "Icons", type: IMAGE }]);
  const [selectedInventoryId, setSelectedInventoryId] = useState(null);
  const { inventoryList, defaultInventory } = useSelector(state => state.projectSlice);
    const [filteredInventory, setFilteredInventory] = useState({[IMAGE]: []});

  useEffect(()=>{
    setSelectedInventoryId(hotspotId);
  },[hotspotId]);

  useEffect(() => {
    setFilteredInventory({
      [IMAGE]: defaultInventory
    });
  }, [defaultInventory]);

  const handleFileChange = async (files) => {

    const updatedFiles = Array.from(files).map((file, index) => ({
      file,
      progress: 0,
      uploading: true,
      preview: URL.createObjectURL(file),
      isNew: true,
    }));

    setFilteredInventory((pre) => ({
      ...pre,
      [activeTab]: [...updatedFiles, ...pre[activeTab]],
    }));

    // updatedFiles.forEach((file) => {
    //   uploadFile(file.file);
    // });

    const uploadPromises = updatedFiles.map((fileObj) => uploadFile(fileObj.file));
    let _list = await Promise.all(uploadPromises);
    handleSubmit(_list);
  };

  const updateFileProgress = (file, path, fileType, currentActiveTab, thumbnail) => {
    setFilteredInventory((prev) => {
      const updatedTabItems = prev[currentActiveTab].map((item) =>
        item.file === file
          ? {
              ...item,
              name: file.name,
              path,
              fileType,
              uploading: false,
              thumbnail: thumbnail,
              isNew: false
            }
          : item
      );

      return {
        ...prev,
        [currentActiveTab]: updatedTabItems,
      };
    });
  };

  const uploadFile = async (file) => {

    const formData = new FormData();
    formData.append('file', file);
    const fileType = getFileType(file.type);

    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await axios.post(`${configData.config.API_URL}/api/inventory/upload/${uuid}/${fileType}`, formData, {
          headers: {
            Authorization: `Bearer ${userData?.token}`,
            'Content-Type': 'multipart/form-data',
          }
        });

        updateFileProgress(file, data?.url, fileType, activeTab, data?.thumbnail);
        resolve({ originalName: file.name, path: data.url, fileType, thumbnail: data?.thumbnail });
      } catch (error) {
        console.log(error.message);
        reject(error);
      }
    });
  };

  const handleInputChange = (event) => {
    const files = event.target.files;
    const validFiles = [];

    for (let i = 0; i < files.length; i++) {
      const file = files[i];
      const fileType = file.type;
      const isValidType =
        (activeTab === IMAGE && fileType.startsWith("image/")) ||
        (activeTab === VIDEO && fileType.startsWith("video/")) ||
        (activeTab === PDF && fileType === "application/pdf") ||
        (activeTab === AUDIO && fileType.startsWith("audio/"));
      if (isValidType) validFiles.push(files[i]);
    }

    if (validFiles.length > 0) {
      handleFileChange(validFiles);
    }
  };

  const handleSubmit = async (_list) => {
    try {
      let _data = { data: _list };

       let {data} = await axios.post(`${configData.config.API_URL}/api/inventory/icon/save/${uuid}`, _data, {
        headers: {
          Authorization: `Bearer ${userData?.token}`,
        }
      });

    } catch (error) {
      console.log(error.message);
    }
  };

  const renderItems = (items, type, inventoryId) => {

    return (
      <>
        <div className="libraryItem add">
          <PlusIcon />
          <input
            type="file"
            id="fileUpload"
            name="fileUpload"
            multiple
            onChange={handleInputChange}
            accept={getAcceptType(activeTab)}
          />
        </div>
        {items.map((item, index) => {
          const {isNew, path, preview, uuid, name, thumbnail} = item;
           const filePath = isNew ? preview : path;
          const isSelected = uuid === hotspotId;

          const renderInventoryContent = () => {
            switch (type) {
              case IMAGE:
                return !isNew ? (
                  <img src={filePath} alt="Library Item" style={{ width: "100%", height: "auto" }} />
                ) : (
                  <SpinnerLoader />
                )
              default:
                return null;
            }
          };
          
          return (
            <div className={`libraryItem ${isNew ? "loading" : ""} ${isSelected ? "selectedItem" : ""} `} key={index} onClick={() => handleSelectScene(item)} >
              
              {renderInventoryContent()}
              
              {isSelected && 
              <span className="selected">
                <MediaCheckIcon/>
              </span>
                }
              <p title={item.name}>{item?.name}</p>
            </div>
          );
        })}
      </>
    );
  };

  const handleSelectScene = (item) =>{
        if(handleChangeHotspot) handleChangeHotspot(item)
  }

  return (
    <Modal show={show} size="xl" centered onHide={handleClose} className="editorModal">
      <Modal.Header>
        <Modal.Title>Libraries</Modal.Title>
        <div className="modalHeaderFunction">
          <span className="modalClose" onClick={handleClose}>
            <XIcon />
          </span>
        </div>
      </Modal.Header>

      <Modal.Body>
        <div className="libraryContent forIcons">
          <div className="customDataTabs">
            {inventoryType.map(({ name, type }) => (
              <span key={type} className={`dataTab ${activeTab === type ? "active" : ""}`} onClick={() => setActiveTab(type)} >
                {name}
              </span>
            ))}
          </div>
          <div className="libraryData">
            {renderItems(filteredInventory[activeTab] || [], activeTab, selectedInventoryId )}
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default IconPopup;
